import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { User, Search, X } from 'lucide-react';

export default function CustomerPicker({
  selectedCustomer, setSelectedCustomer,
  customerSearch, setCustomerSearch,
  filteredCustomers, pickCustomer,
  guestName, setGuestName,
  guestPhone, setGuestPhone,
  guestEmail, setGuestEmail,
}) {
  return (
    <Card className="p-4 space-y-3">
      <Label className="text-xs uppercase font-bold text-muted-foreground flex items-center gap-1">
        <User className="w-3 h-3" /> Customer
      </Label>

      {selectedCustomer ? (
        <div className="flex items-center justify-between p-3 bg-emerald-50 rounded-xl border border-emerald-200">
          <div>
            <p className="font-bold">{selectedCustomer.name}</p>
            <p className="text-xs text-muted-foreground">{selectedCustomer.phone} · {selectedCustomer.email}</p>
          </div>
          <Button variant="ghost" size="sm" onClick={() => setSelectedCustomer(null)} data-testid="clear-customer">
            <X className="w-4 h-4" />
          </Button>
        </div>
      ) : (
        <>
          <div className="relative">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <Input
              data-testid="customer-search"
              placeholder="Search by name, phone, or email…"
              value={customerSearch}
              onChange={(e) => setCustomerSearch(e.target.value)}
              className="pl-9"
            />
            {filteredCustomers.length > 0 && (
              <div className="absolute left-0 right-0 mt-1 z-10 bg-white border border-slate-200 rounded-xl shadow-lg overflow-hidden">
                {filteredCustomers.map((c) => (
                  <button
                    key={c.id}
                    type="button"
                    onClick={() => pickCustomer(c)}
                    data-testid={`customer-pick-${c.id}`}
                    className="w-full text-left px-3 py-2 hover:bg-emerald-50 border-b last:border-b-0"
                  >
                    <p className="font-semibold text-sm">{c.name || '(no name)'}</p>
                    <p className="text-xs text-muted-foreground">{c.phone || '—'} · {c.email || '—'}</p>
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="text-xs text-muted-foreground">— or enter as guest —</div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <Input placeholder="Guest name" value={guestName} onChange={(e) => setGuestName(e.target.value)} data-testid="guest-name" />
            <Input placeholder="+673 ..." value={guestPhone} onChange={(e) => setGuestPhone(e.target.value)} data-testid="guest-phone" />
            <Input placeholder="Email (optional)" value={guestEmail} onChange={(e) => setGuestEmail(e.target.value)} data-testid="guest-email" />
          </div>
        </>
      )}
    </Card>
  );
}
